.pops[type-value="iframe"] {
  --container-title-height: 55px;
  transition:
    width 0.35s ease,
    height 0.35s ease;
}
.pops[type-value="iframe"] .pops-content {
  overflow: hidden;
}
.pops-loading {
  position: absolute;
  top: 40px;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 5;
  background-color: rgb(255, 255, 255, var(--pops-bg-opacity));
}
.pops-loading:before {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 3;
  display: block;
  margin: -20px 0 0 -20px;
  padding: 20px;
  border: 4px solid rgb(221, 221, 221, var(--pops-bd-opacity));
  border-radius: 50%;
  content: "";
  border-top-color: transparent;
  animation: pops-anim-wait-rotate 1.2s linear infinite;
}
.pops[type-value="iframe"].pops[type-module="min"] {
  bottom: 0;
  max-width: 200px;
  max-height: 53px;
  position: unset;
}
.pops[type-value="iframe"].pops[type-module="min"] .pops-header-control[data-type="min"] {
  display: none;
}
.pops[type-value="iframe"].pops-iframe-unset-top {
  top: unset !important;
}
.pops[type-value="iframe"].pops-iframe-unset-left {
  left: unset !important;
}
.pops[type-value="iframe"].pops-iframe-unset-transform {
  transform: none !important;
}
.pops[type-value="iframe"].pops-iframe-unset-transition {
  transition: none !important;
}
.pops[type-value="iframe"].pops[type-module="max"] {
  width: 100% !important;
  height: 100% !important;
}
.pops[type-value="iframe"] iframe[pops] {
  width: 100%;
  height: 100%;
  border: 0;
}
.pops-iframe-content-global-loading {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999;
  width: 0;
  height: 4px;
  background: linear-gradient(to right, #4995dd, #fff, rgb(202 224 246));
  animation: iframeLoadingChange 2s forwards;
}

.pops-anim:has(.pops[type-value="iframe"].pops[type-module="min"]) {
  position: unset;
}
